module.exports = __webpack_public_path__ + "static/media/promo3-2.d80e2b45.svg";